/// <amd-module name="Wit/UI/Card/Components/WorkItemCard/WorkItemCard" />
import * as React from "react";
import { css } from "VSS/Platform/Layout";
import { hexToRgb } from "Wit/UI/Common/ColorUtilities";
import { IWorkItemCardColorInformation, IWorkItemCardProps } from "./WorkItemCard.Props";

export class WorkItemCard extends React.PureComponent<IWorkItemCardProps> {
    public render(): JSX.Element {
        const { className, color, children, saving } = this.props;

        let colorInformation: IWorkItemCardColorInformation | undefined;
        if (color) {
            colorInformation = getCardColorInformation(color);
        }

        return (
            <div className={css("work-item-card flex-column", className)} style={{ backgroundColor: colorInformation && colorInformation.cardColor }}>
                {(typeof children === "function" &&
                    (children as ((colorProps: IWorkItemCardColorInformation | undefined) => React.ReactNode | React.ReactNode[]))(
                        colorInformation
                    )) ||
                    children}
                {saving && <div className="work-item-card-saving-overlay absolute-fill" />}
            </div>
        );
    }
}

function getCardColorInformation(baseColor: string): IWorkItemCardColorInformation {
    const parsedColor = hexToRgb(baseColor);
    const tintFactor = 0.8;

    const tintedColor = parsedColor.map(x => x + (255 - x) * tintFactor);

    return {
        cardColor: baseColor,
        coreColor: `rgb(${tintedColor[0]},${tintedColor[1]},${tintedColor[2]})`
    };
}
